import React from 'react';
import PropTypes from 'prop-types';
import round from 'lodash/round';
import clsx from 'clsx';
import MLIcon from '../../../../../../components/MLIcon/MLIcon';
import styles from './SRLDifferenceIndicator.module.css';

const renderIndicator = (formattedDifference, unitOfMeasurement) => {
  if (formattedDifference !== 0) {
    const positiveTrend = formattedDifference > 0;
    const iconType = positiveTrend ? 'chevron_double_up' : 'chevron_double_down';
    return (
      <div className={styles.indicator}>
        <MLIcon
          className={styles.trendIcon}
          type={iconType}
          role="presentation"
          width="20"
          height="20"
        />
        <span className={styles.value}>{Math.abs(formattedDifference)}</span>
        <span className={styles.unit}>{unitOfMeasurement}</span>
      </div>
    );
  }
  return (
    <div className={clsx(styles.indicator, styles.value)}> no change </div>
  );
};

function SRLDifferenceIndicator({ lastAssignmentValue, thisAssignmentValue, unitOfMeasurement, numberOfDecimals, containerClasses }) {
  if (!lastAssignmentValue || !thisAssignmentValue) {
    return null;
  }
  const difference = parseFloat(thisAssignmentValue) - parseFloat(lastAssignmentValue);
  const formattedDifference = round(difference, numberOfDecimals);

  return (
    <div className={clsx(styles.container, containerClasses)}>
      {renderIndicator(formattedDifference, unitOfMeasurement)}
      <div className={styles.subtitle}>
        since previous survey
      </div>
    </div>
  );
}

SRLDifferenceIndicator.defaultProps = {
  numberOfDecimals: 0,
};

SRLDifferenceIndicator.propTypes = {
  lastAssignmentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  thisAssignmentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  unitOfMeasurement: PropTypes.string,
  numberOfDecimals: PropTypes.number,
  containerClasses: PropTypes.string,
};

export default SRLDifferenceIndicator;
